import TransactionListComponent from "../../components/admin/transactions/TransactionListComponent";

export default [
    {
        path: '/admin/transacciones',
        component: TransactionListComponent,
        name: 'admin.transactions.list',
        meta: {
            isFrontend: false,
            auth: true,
            permissionUrl: 'transactions',
            breadcrumb: 'transactions'
        }
    }
]
